import HttpClient from "@/common/boot/HttpClient"

const listarWorkflows = async ({ commit }, payload) => {
  commit('CARREGANDO', true);
    await HttpClient.get('/ctrl-workflows', payload).then(response => {
        commit('LISTAR_DADOS', response.data.data);
        return response;
    });
  commit('CARREGANDO', false);
}

const listarTipoAgings = async ({ commit }, payload) => {

  commit('CARREGANDO', true);

  await HttpClient.get('/ctrl-tipos-agings', payload).then(response => {
    commit('LISTAR_DADOS_TIPOS_AGINGS', response.data.data);
    return response;
  }).finally( () => {
    commit('CARREGANDO', false);
  });
}

const excluirWorkflows = async ({ commit, dispatch },  payload) => { 
  commit('CARREGANDO', true);
    let qtdRows = payload.length;
    for(let i=0;i<qtdRows;++i){
      await excluir(payload[i]);
    }
   
    await dispatch('listarWorkflows');

    commit('CARREGANDO', false);
}  

const excluir = async(linha) => {
  const resp = await HttpClient.delete(`/ctrl-workflows/${linha.id}`).then(response => { return response; });
  return resp;
}

const salvarWorkflow = async ({ commit,dispatch }, payload) => {

  commit('CARREGANDO', true);

  return await HttpClient.post('/ctrl-workflows', payload).then(response => {
    dispatch('listarWorkflows');
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  });
}

const recuperarWorkflow = ({ commit, state }, payload) => {

  commit('CARREGANDO', true);

  const item = state.items.filter(item => item.id === payload.id);

  if(item.length) {
    commit('INSERIR_WORKFLOW_SELECIONADO', ...item);
    return true;
  }

  commit('CARREGANDO', false);

  return false;
}

const atualizarWorkflow = async ({ commit, dispatch }, payload) => {
  commit('CARREGANDO', true);

  return await HttpClient.put(`/ctrl-workflows/${payload.id}`, payload).then(response => {
    dispatch('listarWorkflows');
    return response;
  })
  .finally( () => {
    commit('CARREGANDO', false);
  })
}

export {
  listarWorkflows,
  listarTipoAgings,
  excluirWorkflows,
  salvarWorkflow,
  recuperarWorkflow,
  atualizarWorkflow
}